import GA_EVENTS from '../ga_constants';
import { setBehaviourEvent } from '../ga_interface';

function clickOnAccordion(label) {
    const category = GA_EVENTS.ProductDetailAccordion.category;
    const action = GA_EVENTS.ProductDetailAccordion.actions.click;
    
    setBehaviourEvent({ category, action, label });
}

export {
    clickOnAccordion,
};